module.exports = __webpack_public_path__ + "img/td-bg.9c4f4681.png";